export const ADD_REMINDER = 'ADD_REMINDER'
export const TOGGLE_REMINDER = 'TOGGLE_REMINDER'
export const DELETE_REMINDER = 'DELETE_REMINDER'
export const CLEAR_REMINDERS = 'CLEAR_REMINDERS'
export const SET_SORT_FILTER = 'SET_SORT_FILTER'
export const SET_VISIBILITY_FILTER = 'SET_VISIBILITY_FILTER'
